module.exports = __webpack_public_path__ + "img/fire2.611f663b.svg";